import React from "react";

const defaultData: any = { user: null };

const UserContext = React.createContext(defaultData);

export default UserContext;
